import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import ToggleBulkAssigneeTagRequest from "../request/ToggleBulkAssigneeTagRequest";

const ToggleBulkAssigneeTagApiService = async (
  request: ToggleBulkAssigneeTagRequest
): Promise<boolean> => {
  const actionUrl = request.isTagged
    ? "bulk_tag_employee"
    : "bulk_un_tag_employee";
  const url = `/employertag/${request.tagId}/${actionUrl}/`;
  const { data } = await axios.post(url, {
    employees: request.employees,
  });
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useToggleBulkAssigneeTagApiService = () =>
  useMutation<boolean, AxiosError, ToggleBulkAssigneeTagRequest>(
    ToggleBulkAssigneeTagApiService,
    {
      mutationKey: ["ToggleBulkAssigneeTagApiService"],
    }
  );
export default useToggleBulkAssigneeTagApiService;
